import React from 'react';
import { string } from 'prop-types';

function SocialLink({ className, target, rel, iClassName, href }) {
  return (
    <a className={className} rel={rel} target={target} href={href}>
      <i className={iClassName} />
    </a>
  );
}

SocialLink.defaultProps = {
  className: '',
  iClassName: '',
  rel: 'noopener noreferrer',
  target: '_blank'
};

SocialLink.propTypes = {
  href: string.isRequired,
  className: string,
  iClassName: string,
  rel: string,
  target: string
};

export default SocialLink;
